<template>
  <div class="app" ref="app">
    <div v-if="pages2.length > 0" class="page-list">
      <!-- @click="changeGrowPage(index)" -->
      <div
        v-for="(pageitem, index) in pages2"
        :key="pageitem.c_id"
        class="cell"
        ref="dragbox"
      >
        <div  
          class="dragbox"
          
          :style="{ height: (750 * dragboxWidth) / wrapperWidth + 'px' }"
        >
          <div
            class="wrapper"
            :style="{
              transform: `scale(${(dragboxWidth) / wrapperWidth})`,
            }"
          >
            <div
              class="wrap2"
              :class="pageitem.noFillNum ? 'nofill' :'filled'"
              :style="{
                width: wrapperWidth + 'px',
                height: 750 + 'px',
                backgroundImage: 'url(' + pageitem.img_bg + ')',
                backgroundSize: '100% 100%',
                backgroundColor: '#cccccc',
              }"
            > 
              
              <vue-draggable-resizable
                v-for="(item, index2) in pageitem.content"
                :key="item.ec_id"
                :w="item.width"
                :h="item.height"
                :enableNativeDrag="true"
                :x="item.left"
                :y="item.top"
                :r="item.rotate"
                :filled="item.filled"
                :levelNum="item.levelNum"
                :photoRotate="item.photoRotate"
                :levelType="item.levelType"
                :level="item.level"
                :z="item.zIndex"
                :fontFamily="item.fontFamily"
                :frameId="'item' + index + index2"
                :textDecoration="item.textDecoration" :textIndent="item.textIndent" :writingMode="item.writeMode"
                :photoScale="item.photoScale"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :showPhoto="item.showPhoto"
                :shadow="item.shadow ? true : false"
                :allIndex="item.allIndex"
                :dIndex="index"
                :debug="false"
                :disable="true"
                :lineHeight="item.lineHeight"
                :fontWeight="item.fontWeight"
                :fontStyle="item.fontStyle"
                :textAlign="item.textAlign"
                :type="item.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''"
                :bImg2="item.backImg2"
                :bRadius="item.borderRadius"
                :fontColor="item.fColor"
                :text="item.textarea"
                :o="item.opacity"
                :l="item.lock ? true : false"
                dragHandle="false"
                :backColor="item.bColor"
                :borderColor="item.bordersColor"
                :borderLeft="item.bLeft"
                :borderTop="item.bTop"
                :borderRight="item.bRight"
                :borderBottom="item.bBottom"
                :borderStyle="item.bStyle"
                :paddingLeft="item.paddingLeft"
                :paddingTop="item.paddingTop"
                :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom"
                :active="false"
                :fontSize="item.fSize"
              >
                <div v-if="item.type == 3" class="look" style="z-index:-1">
                  <div
                    class="wrap"
                    :style="{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      transform: `scale(${item.width /
                        item.orignWidth},${item.height / item.orignHeight})`,
                      transformOrigin: '0px 0px',
                    }"
                  >
                    <vue-draggable-resizable
                      v-for="(item2, index2) in item.coms"
                      :key="index2"
                      :w="item2.width"
                      :h="item2.height"
                      :x="item2.left"
                      :y="item2.top"
                      :r="item2.rotate"
                      :z="item2.zIndex"
                      :levelType="item2.levelType"
                      :level="item2.level"
                      :showPhoto="item2.showPhoto"
                      :shadow="item2.shadow ? true : false"
                      :allIndex="item.coms.length - 1"
                      :dIndex="index"
                      :debug="false"
                      :disable="true"
                      :textDecoration="item.textDecoration" :textIndent="item.textIndent" :writingMode="item.writeMode"
                      :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight"
                      :fontStyle="item2.fontStyle"
                      :textAlign="item2.textAlign"
                      :type="item2.type"
                      :isConflictCheck="false"
                      :snap="true"
                      :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                      :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius"
                      :fontColor="item2.fColor"
                      :text="item2.textarea"
                      :o="item2.opacity"
                      :l="item2.lock ? true : false"
                      dragHandle="false"
                      :backColor="item2.bColor"
                      :borderColor="item2.bordersColor"
                      :borderLeft="item2.bLeft"
                      :borderTop="item2.bTop"
                      :borderRight="item2.bRight"
                      :borderBottom="item2.bBottom"
                      :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft"
                      :paddingTop="item2.paddingTop"
                      :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom"
                      :active="false"
                      :fontSize="item2.fSize"
                    ></vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable>
              <div v-if="pageitem.noFillNum" class="fill">
                {{pageitem.noFillNum}}
              </div>
            </div>
          </div>
        </div>
        <div class="name">
          {{
            pageitem.type == 1
              ? "封面"
              : pageitem.type == 3
              ? "封底"
              : pageitem.page_num
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "mobileGrowup",
  components: {
    VueDraggableResizable,
  },
  data() {
    return {
      pages2: [],
      s_id: "",
      page: 0,
      allIndex: 0,
      wrapperWidth: 100,
      cover_size: [],
      dragboxWidth: 100,
      haomi: 3,
      is_complete:false,
      grow_up_name:''
    };
  },
  props:{
    guc_id:{
      type:String,
      default:''
    },
    sid:{
      type:String | Number,
      default:''
    }
  },
  computed: {
    ...mapState(["headers", "userInfo", "fonts"]),
    leftChatStyle() {
      return {
        cursor: this.leftChatMouseStateMove ? "grab" : "auto",
      };
    },
    wrapperStyle() {
      return {
        width: this.wrapperWidth + "px",
        height: 750 + "px",
        transform: `scale(${this.sizeSelct / 100}) translate(${
          this.bodyTranslateX
        }px,${this.bodyTranslateY}px)`,
      };
    },
  },
  created() {
    this.getGrowupPageDetail();
  },
  mounted() {
    this.dragboxWidth = document.body.clientWidth / 3 - 40
    if (!this.guc_id) {
      this.dragboxWidth = document.body.clientWidth / 3 - 40
    } else {
      this.dragboxWidth = this.$refs.app.getBoundingClientRect().width / 3 -40
    }

    window.onresize = () => {
      if (!this.guc_id) {
        this.dragboxWidth = document.body.clientWidth / 3 - 40
      } else {
        this.dragboxWidth = this.$refs.app.getBoundingClientRect().width / 3 -40
      }
    }
  },
  watch:{
    guc_id() {
      this.getGrowupPageDetail()
      if (!this.guc_id) {
        this.dragboxWidth = document.body.clientWidth / 3 - 40
      } else {
        this.dragboxWidth = this.$refs.app.getBoundingClientRect().width / 3 -40
      }
    }
  },
  methods: {
    getGrowupPageDetail(state) {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.getGrowupSize,
        params: {
          guc_id: this.guc_id ? this.guc_id : this.$route.params.guc_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            var cover_size = res.data.data.cover_size.split("*");
            this.cover_size = cover_size;
            this.haomi = (11.8 * 3 * 750) / cover_size[1];
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            // this.is_complete  = res.data.data.info.is_complete ? true : false
            this.getGrowPages();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res);
        });
    },
    getGrowPages() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growPages,
        // headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id ? this.guc_id : this.$route.params.guc_id,
          s_id: this.sid ? this.sid : this.$route.params.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.pages2 = res.data.data;
            this.pages2.forEach((arr, index) => {
              this.pages2[index].content.allIndex =
                this.pages2[index].content.length - 1;
              this.pages2[index].img_bg =this.clearUrl(this.pages2[index].img_bg)  +
                "?x-image-process=image/resize,w_600/quality,Q_120";
                var noFillNum = 0
              this.pages2[index].content = arr.content.map((arr) => {
                if (arr.textarea) {
                  arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
                }
                console.log(arr.textarea);
                // arr.draggable = true
                arr.backgroundImg = arr.backgroundImg? this.clearUrl(arr.backgroundImg) +
                  "?x-image-process=image/resize,w_350/quality,Q_80" : '';
                arr.backImg2 = arr.backImg2 ? this.clearUrl(arr.backImg2) +
                  "?x-image-process=image/resize,w_350/quality,Q_80" : '';
                arr.showPhoto = arr.showPhoto ? this.clearUrl(arr.showPhoto) +
                  "?x-image-process=image/resize,w_350/quality,Q_80" : '';
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                  if (arr.coms[0] && arr.coms[0].width >=0) {

                  } else {
                    arr.coms = []
                  }
                }
                if ((arr.type == 1 || arr.type == 2 || arr.type == 9) && !arr.is_filled) {
                  noFillNum++
                } 
                if (arr.type == 0 && arr.is_count && !arr.is_filled && !arr.backgroundImg) {
                  noFillNum++
                } 
                if (arr.type == 5  && !arr.is_filled && !arr.backgroundImg) {
                  noFillNum++
                } 
                return arr;
              });
              this.pages2[index].noFillNum = noFillNum
            });
            this.$forceUpdate();
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    urladd(name) {
      let url = window.location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.body {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.student-list {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.content img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.photo-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 99px;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  position: relative;
  .img {
    width: 100%;
    height: auto;
  }
  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}
.dragtext {
  width: 99px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  color: #333;
  border: 1px solid #666;
  margin-bottom: 10px;
}
.photo-item .look {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.back-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 100px;
  float: left;
  box-sizing: border-box;
  margin: 6px 10px;
}
.plate-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  .cell {
    width: 134px;
    margin-right: 20px;
    height: 180px;
    background: #eee;
    position: relative;
    margin-bottom: 60px;
    &.select {
      border: 2px solid #9ebee4;
    }
    .name {
      position: absolute;
      left: 0;
      top: 185px;
      color: #888;
      line-height: 1.2;
      padding: 5px;
      box-sizing: border-box;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}
.back-item .back {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  position: relative;
  .times {
    position: absolute;
    right: 0;
    top: 0;
    padding: 4px 6px;
    color: #fff;
    background: #ff0000;
    border-radius: 16px;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    transform: translate(50%, -50%);
  }
}
.back-item .back .img {
  width: 100%;
  height: auto;
  max-height: 160px;
  background: #f3f3f3;
  display: block;
}
.photo-item .look .img {
  width: 100%;
  background: #f3f3f3;
  display: block;
}
.photo-item .name {
  text-align: center;
}
body,
html {
  background: #f3f3f3;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}
.page-list {
  width: 100%;
  overflow: hidden;
  .cell {
    width: 33.33%;
    float: left;
    margin: 10px 0;
    overflow: hidden;
    .dragbox {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .cover {
      width: 120px;
      height: 170px;
      background: #eee;
      margin-bottom: 15px;
      background-size: contain;
    }
    .name {
      color: #666666;
      font-size: 14px;
      text-align: center;
      height: 20px;
      margin-top: 10px;
      line-height: 20px;
      z-index: 100;
    }
  }
}
.nofill{
  border: 3px dashed #ff0000;
  position: relative;
  .fill{
    position: absolute;
    right: 0;
    top: 0;
    text-align: center;
    color: #fff;
    padding:4px 20px;
    font-size: 4em;
    background: #ff0000;
    z-index: 10000;
  }
}
</style>
